import {Box} from "@mui/material";
import CategoryButton from "@/src/components/main-site/home/journals-section/category-button/category-button";
import CategoryFilterProps from "@/src/_types/category-filter-props";

const CategoryFilter = ({categories, activeCategory, onCategoryChange}: CategoryFilterProps) => (
    <Box sx={{display: "flex", flexWrap: "wrap", gap: ".4rem", mt: 1}}>
        <CategoryButton
            onClick={() => onCategoryChange("all")}
            sx={{
                backgroundColor: activeCategory === "all" ? '#84B817' : '#BFBEBD',
            }}
        >
            All
        </CategoryButton>
        {categories.map((category: any) => (
            <CategoryButton
                key={category}
                variant="contained"
                onClick={() => onCategoryChange(category)}
                sx={{
                    backgroundColor: activeCategory === category ? '#84B817' : '#BFBEBD',
                }}
            >
                {category}
            </CategoryButton>
        ))}
    </Box>
);

export default CategoryFilter;
